/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import React from 'react';
import ReactDOM from 'react-dom/client';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createBrowserHistory } from 'history';
import Root from 'containers/Root';
import configureStore from 'store/configureStore';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import 'vendor/modernizrFlexbox';
import 'styles/application.scss';
import 'rc-tooltip/assets/bootstrap_white.css'
import process from 'process';

import { defaults } from 'chart.js';
import { setQueryClient } from './middleware/communicationQueryMiddleware';

defaults.font.family = 'Nunito';
defaults.font.size = 16;

// Support component names relative to this directory:
// var componentRequireContext = require.context('components', true);
// var ReactRailsUJS = require('react_ujs');
// ReactRailsUJS.useContext(componentRequireContext);

export const TIMEOUTS = {
  timeouts: [],

  clearTimeout: function(id) {
    clearTimeout(id);
    this.timeouts = this.timeouts.filter((timeoutId) => timeoutId !== id);
  },

  setTimeout: function(fn, delay) {
    const id = setTimeout(fn, delay);
    this.timeouts.push(id);
    return id;
  },

  clearAllTimeouts: function() {
    while (this.timeouts.length) {
      clearTimeout(this.timeouts.pop())
    }
  },
}

window.TIMEOUTS = TIMEOUTS;

const loadApp = () => {
  if (!(Modernizr.flexbox && Modernizr.flexwrap)) return;

  const rootElement = ReactDOM.createRoot(document.getElementById('root'))
  if (!rootElement) {
    return;
  }

  const history = createBrowserHistory();
  const store = configureStore(history);
  const queryClient = new QueryClient();

  setQueryClient(queryClient)

  rootElement.render(
    <QueryClientProvider client={queryClient}>
      <Root store={store} history={history} />
      <ToastContainer
        position="top-right"
      />
      { !process.env.TANSTACK_DEV_TOOLS_DISABLED && process.env.NODE_ENV === 'development' && <ReactQueryDevtools /> }
    </QueryClientProvider >
  );
};

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
  loadApp();
} else {
  document.addEventListener('DOMContentLoaded', loadApp);
}
